/** Explicit source append into the existing pasteable area. Preserve the original bytes and
 * deduplicate whole lines, never substrings that can swallow a different objective. */
export function appendSourceLines(original: string, lines: string[]): string {
  const present = new Set(original.split(/\r?\n/).map((line) => line.replace(/^[-*]\s+/, "").trim()));
  const additions = [...new Set(lines)].filter((line) => line.trim() && !present.has(line.trim()));
  return additions.length ? original + (original && !original.endsWith("\n") ? "\n" : "") + additions.map((line) => `- ${line}`).join("\n") : original;
}

export function planningWeekHref(classId: string, termId: string | null, week: number, nodeId?: string | null, lessonId?: string | null): string {
  const q = new URLSearchParams({ class: classId, week: String(week) });
  if (termId) q.set("term", termId);
  if (nodeId) q.set("node", nodeId);
  if (lessonId) q.set("lesson", lessonId);
  return `/this-week?${q}`;
}
